import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(HttpApi)
  .init({
    lng: 'ar',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },

    detection: {
      caches: ['localStorage'],
      order: ['localStorage', 'htmlTag', 'path'],
    },

    backend: {
      backendOptions: [
        { loadPath: '/locales/{{lng}}/translation.json' },
        { expirationTime: 60 * 60 * 1000 }, // 1 hour
      ],
    },
  });

export default i18n;
